<template>
    <div>
        <a href="#" @click.prevent.stop="showModal=true">Edit</a>

        <b-modal v-model="showModal" title="Edit Company Account Information" hide-footer @hidden="resetForm">
            <b-form @submit="handleSubmit">
                <b-form-group label="COMPANY NAME" label-class="text-truncate label-required">
                    <b-form-input v-model="name" required/>
                </b-form-group>

                <b-form-group label="COUNTRY" label-class="text-truncate label-required">
                    <country-select class="form-control"
                                    v-model="country"
                                    :country="country"
                                    topCountry="US"
                                    required
                                    :countryName="true"/>
                </b-form-group>

                <b-row>
                    <b-col lg="6">
                        <b-form-group label="STATE" label-class="text-truncate label-required">
                            <region-select :regionName="true"
                                           :countryName="true"
                                           class="form-control"
                                           v-model="state"
                                           required
                                           :country="country"
                                           :region="state"/>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6">
                        <b-form-group label="ZIP" label-class="text-truncate">
                            <b-form-input v-model="zip"/>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-form-group label="CITY" label-class="text-truncate label-required">
                    <b-form-input v-model="city" required/>
                </b-form-group>

                <b-form-group label="ADDRESS LINE 1" label-class="text-truncate label-required" label-for="input-line1">
                    <b-form-input v-model="line1" required id="input-line1"/>
                </b-form-group>

                <b-form-group label="ADDRESS LINE 2" label-class="text-truncate">
                    <b-form-input v-model="line2"/>
                </b-form-group>

                <b-form-group label="INDUSTRY" label-class="text-truncate">
                    <b-form-select v-model="industry" :options="industries"/>
                </b-form-group>

                <b-form-group label="PHONE NUMBER" label-class="text-truncate">
                    <b-form-input v-model="phoneNumber"/>
                </b-form-group>

                <b-form-group label="WEBSITE URL" label-class="text-truncate">
                    <b-form-input v-model="website"/>
                </b-form-group>

                <b-row class="mt-4 mb-2">
                    <b-col class="ml-auto" cols="auto">
                        <b-button variant="light"
                                  class="btn-rounded px-3"
                                  @click="closeModal"
                                  :disabled="saving">
                            Cancel
                        </b-button>
                        <b-button variant="primary"
                                  class="btn-rounded px-3"
                                  type="submit"
                                  :disabled="saving">
                            <span v-if="saving">Please Wait...</span>
                            <span v-else>Save</span>
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
  import GeneralMixins from "../../../mixins/GeneralMixins";

  export default {
    props: ['organization', 'organizationsUrl', 'industries'],
    mixins: [GeneralMixins],

    data: function () {
      return {
        name: null,
        line1: null,
        line2: null,
        city: null,
        state: null,
        zip: null,
        country: null,
        website: null,
        phoneNumber: null,
        industry: null,
        saving: false,
        showModal: false
      }
    },

    created() {
      this.resetForm();
    },

    methods: {
      handleSubmit(evt) {
        evt.preventDefault();
        this.saving = true;
        this.$http.patch(this.organizationsUrl, this.params).then(fulfilled => {
          // Turbolinks.clearCache()
          // Turbolinks.visit(location.href, {"action": "replace"})
          location.reload()
          this.saving = false;
        }, rejected => {
          this.saving = false;
          this.showErrorToast(this.getErrorMessages(rejected.body, true))
        })
      },

      closeModal() {
        this.showModal = false;
        this.resetForm();
      },

      resetForm() {
        this.name = this.organization.name;
        this.line1 = this.organization.address_line_1;
        this.line2 = this.organization.address_line_2;
        this.city = this.organization.address_city;
        this.state = this.organization.address_state;
        this.zip = this.organization.address_zip;
        this.country = this.organization.address_country;
        this.website = this.organization.website;
        this.industry = this.organization.industry;
        this.phoneNumber = this.organization.phone_number;
      }
    },

    computed: {
      isAgency() {
        return this.organization.organization_type === "agency"
      },
      params() {
        let params = {
          organization: {
            name: this.name,
            address_line_1: this.line1,
            address_line_2: this.line2,
            address_city: this.city,
            address_state: this.state,
            address_zip: this.zip,
            address_country: this.country,
            website: this.website,
            industry: this.industry,
            phone_number: this.phoneNumber
          }
        }

        return params
      }
    }
  }
</script>